import React from 'react'

export default ({ children, onClick }) => {
  return (
    <button
      onClick={(evt) => onClick()}>
      {children}
    </button>
  )
}